module.exports = __webpack_public_path__ + "static/media/turnos_web.cf992b8d.pdf";